import { useEffect } from 'react';
import { useStore } from '../data/store';
import Navigation from '../components/public/Navigation';
import Footer from '../components/public/Footer';
import BandApplication from '../components/public/BandApplication';
import CookieBanner from '../components/public/CookieBanner';

export default function BewerbenPage() {
  const fetchPublicData = useStore((s) => s.fetchPublicData);
  const loading = useStore((s) => s.loading);

  useEffect(() => {
    fetchPublicData();
    window.scrollTo(0, 0);
  }, [fetchPublicData]);

  if (loading) {
    return (
      <div className="min-h-screen bg-bg-primary flex items-center justify-center">
        <div className="text-text-muted font-body">Laden...</div>
      </div>
    );
  }

  return (
    <>
      <Navigation />
      <main id="main-content" className="pt-16 md:pt-20">
        <BandApplication />
      </main>
      <Footer />
      <CookieBanner />
    </>
  );
}
